import { type FC } from "react";
import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SupportRequestStatusType } from "@/types/graphql/partner.generated";
import { REQUEST_STATUS_LABEL_KEY } from "../model/labels";

const STATUS_COLOR: Record<
  SupportRequestStatusType,
  "default" | "warning" | "info" | "success" | "error"
> = {
  [SupportRequestStatusType.DraftType]: "default",
  [SupportRequestStatusType.OpenType]: "warning",
  [SupportRequestStatusType.WaitingViewerType]: "info",
  [SupportRequestStatusType.ViewerRepliedType]: "error",
  [SupportRequestStatusType.ClosedType]: "success",
  [SupportRequestStatusType.CancelledType]: "default",
};

export const SupportRequestStatusChip: FC<{
  status: SupportRequestStatusType;
}> = ({ status }) => {
  const { t } = useTranslation();

  return (
    <Chip
      size="small"
      color={STATUS_COLOR[status]}
      label={t(REQUEST_STATUS_LABEL_KEY[status])}
    />
  );
};
